export function getSessionVerificationStatus(error: unknown): number | undefined {
  return (error as { response?: { status?: number } })?.response?.status;
}
